<aside class="media-support-material-aside">
    <app-accordion
        accordionTitle="Media in This Lesson"
        class="mb-6 selenium-support-media"
        [instanceId]="mediaInLessonAccordionId"
        [isExpanded]="true"
        *ngIf="resource.lessonContents.length"
    >
        <ng-container *ngFor="let lessonContent of resource.lessonContents">
            <app-lesson-content class="mb-4" [lessonContent]="lessonContent" appAccordionItem>
            </app-lesson-content>
        </ng-container>
    </app-accordion>
    <app-accordion
        accordionTitle="Support Materials for Teachers"
        class="mb-6 selenium-support-teachers"
        [instanceId]="supportMaterialForTeachersAccordionId"
        [isExpanded]="!resource.lessonContents.length"
        *ngIf="resource.supportMaterialsForTeachersByCategory.length && isTeacherPreview"
    >
        <ng-container *ngFor="let smByCategory of resource.supportMaterialsForTeachersByCategory">
            <h6 appAccordionItem noCount class="category mb-2">{{ smByCategory.category }}</h6>
            <a
                href="#"
                appAccordionItem
                (click)="openSupportMaterial(sm, $event)"
                [attr.data-gtmlabel]="'Teacher - ' + smByCategory.category"
                class="mb-4 gtm-support-material-item selenium-support-material-item support-material-item"
                *ngFor="let sm of smByCategory.items"
                [title]="sm.title"
            >
                {{ sm.title }}
            </a>
        </ng-container>
    </app-accordion>
    <app-accordion
        accordionTitle="Support Materials for Use with Students"
        class="selenium-support-students"
        [instanceId]="supportMaterialForStudentsAccordionId"
        [isExpanded]="
            (!resource.lessonContents.length &&
                !resource.supportMaterialsForTeachersByCategory.length) ||
            isTeacherPreview
        "
        *ngIf="resource.supportMaterialsForStudentsByCategory.length"
    >
        <ng-container *ngFor="let smByCategory of resource.supportMaterialsForStudentsByCategory">
            <h6 appAccordionItem noCount class="category mb-2">{{ smByCategory.category }}</h6>
            <a
                href="#"
                appAccordionItem
                (click)="openSupportMaterial(sm, $event)"
                [attr.data-gtmlabel]="'Student - ' + smByCategory.category"
                class="mb-4 gtm-support-material-item selenium-support-material-item support-material-item"
                *ngFor="let sm of smByCategory.items"
                [title]="sm.title"
            >
                {{ sm.title }}
            </a>
        </ng-container>
    </app-accordion>
</aside>
